<template>
  <div>
    <div class="p-5 text-white bg-primary relative fl-sym-bg-primary">
    <div class="fl-sym-p-5 fl-sym-relative" @click="$emit('onBack')">
        <div class="fl-sym-absolute fl-sym-inset-y-0 fl-sym-left-0 fl-sym-flex fl-sym-justify-center fl-sym-items-center fl-sym-pl-4 fl-sym-text-4xl fl-sym-text-white">
          <img src="@/assets/chevron-left-thin.svg" width="15" class="chevron-left-thin">
        </div>
        <img src="@/assets/logo.svg" @click="goHome" width="147" class="fl-sym-mx-auto fl-sym-cursor-pointer"/>
      </div>
    </div>
    <div class="fl-sym-text-black fl-sym-p-5">
      <div class="text-3xl font-bold fl-sym-text-3xl fl-sym-font-bold fl-sym-mb-2 fl-sym-mt-20">
        Your pet’s main emergency symptom is....
      </div>
      <div class="fl-sym-text-xl fl-sym-font-bold fl-sym-font-light fl-sym-mb-1 fl-sym-mt-5">
        {{answer.title}}
      </div>
      <div class="fl-sym-mt-5 fl-sym-text-lg">
        {{answer.description}}
      </div>
      <div class="fl-sym-mt-40 text-center">
        <button class="fl-sym-w-full fl-sym-border-2 fl-sym-border-intermediate fl-sym-text-primary fl-sym-text-sm hover:fl-sym-border-primary fl-sym-rounded-full fl-sym-p-4 fl-sym-font-semibold fl-sym-mb-3">
          Yes, this is correct
          <div class="fl-sym-float-right">
            <font-awesome-icon icon="chevron-right"></font-awesome-icon>
          </div>
        </button>
        <div class="fl-sym-flex fl-sym-justify-center fl-sym-text-lg fl-sym-mt-5">
        <span class="mx-auto fl-sym-text-primary hover:fl-sym-text-opacity-75">
          Back
        </span>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      answer: {
        title: 'Fit or seizure',
        description: 'Temporary involuntary of normal brain function accompanied by uncontrollable muscle activity.'
      }
    }
  }
}
</script>